import Cotter from "./Cotter";
import CotterEnum from "./enum";

class CotterExport extends Cotter {
  static CotterEnum = CotterEnum;
}

export = CotterExport;
